import React, { useState, useEffect } from 'react'

type SignedInStatusContextType = Readonly<{
  custId: number
  email: string
  firstName: string
  lastName: string
  name: string
}>
export const SignedInStatusContext = React.createContext<
  SignedInStatusContextType | undefined
>(undefined)

function SignedInStatusProvider({ children }: { children: React.ReactNode }) {
  const [userInfo, setUserInfo] = useState<SignedInStatusContextType>()
  useEffect(() => {
    const handler = async () => {
      const data = await window?.pclnAuth?.getUserInfo?.()
      setUserInfo(data)
    }
    void handler()
    window.addEventListener('SIGN_IN_COMPLETE', handler)

    return () => {
      window.removeEventListener('SIGN_IN_COMPLETE', handler)
    }
  }, [])
  return (
    <SignedInStatusContext.Provider value={userInfo}>
      {children}
    </SignedInStatusContext.Provider>
  )
}

export default SignedInStatusProvider
